/* fh-transitions.js — Branded page transitions */
(function () {
  'use strict';

  var logoSrc;

  function getLogoSrc() {
    var img = document.querySelector('.header__logo__link img, .header__logo img, [data-header-logo] img');
    return img ? (img.currentSrc || img.src) : null;
  }

  function createOverlay(cls) {
    var ov = document.createElement('div');
    ov.className = 'fh-transition ' + cls;
    if (logoSrc) {
      var logo = document.createElement('img');
      logo.className = 'fh-transition__logo';
      logo.src = logoSrc;
      logo.alt = '';
      ov.appendChild(logo);
    }
    document.body.appendChild(ov);
    return ov;
  }

  function clearEarlyHide() {
    document.documentElement.style.background = '';
    if (window.__fhTrStyle) { window.__fhTrStyle.remove(); window.__fhTrStyle = null; }
  }

  function shouldTransition(link) {
    if (!link || !link.href) return false;
    if (link.target === '_blank') return false;
    if (link.hostname !== location.hostname) return false;
    if (link.getAttribute('href').charAt(0) === '#') return false;
    if (link.href === location.href) return false;
    if (link.closest('[data-fhp-add], [data-fhc-remove], [data-fhc-swap], [data-fhc-qty-minus], [data-fhc-qty-plus], [data-fhc-ghost-add], form')) return false;
    return true;
  }

  function handleEntry() {
    logoSrc = getLogoSrc();
    if (sessionStorage.getItem('fh-tr') === '1') {
      sessionStorage.removeItem('fh-tr');
      var ov = createOverlay('fh-transition--exit');
      clearEarlyHide();
      ov.addEventListener('animationend', function (e) {
        if (e.target === ov) ov.remove();
      });
      setTimeout(function () { if (ov.parentNode) ov.remove(); }, 800);
    } else {
      clearEarlyHide();
    }
  }

  document.addEventListener('click', function (e) {
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest('a');
    if (!link || !shouldTransition(link)) return;

    e.preventDefault();
    var href = link.href;
    sessionStorage.setItem('fh-tr', '1');

    createOverlay('fh-transition--enter');
    setTimeout(function () {
      window.location.href = href;
    }, 300);
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      var existing = document.querySelector('.fh-transition');
      if (existing) existing.remove();
      sessionStorage.removeItem('fh-tr');
      clearEarlyHide();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleEntry);
  } else {
    handleEntry();
  }
})();
